import { defineStore } from 'pinia'

export const FiltersBlock = defineStore({
    id: 'wp_filters_document',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        },
        selected() {
            let selected = []
            if (this.value) {
                for (let filter of this.value) {
                    if (filter.selected && (filter.selected.length > 0 || filter.selected === true)) {
                        selected.push({
                            name: filter.name,
                            id: filter.searchfield,
                            data: filter.selected,
                            __ID: filter.id
                        })
                    }
                }
            }
            return selected
        }
    },
})
